// import routes from "../routes.js";

// const mainRoutes = routes.flatMap((route) => {
//   if (route.hidden) return [];

//   // Remove children from parent
//   const parent = { ...route };
//   delete parent.children;

//   // Get children as top-level routes
//   const children = route.children || [];

//   return [parent, ...children];
// });

// export const organizerRoute = mainRoutes
//   .filter((route) => route.key) // optional: ignore routes without a key
//   .map((route) => ({
//     key: route.key,
//     can_read: false,
//     can_create: false,
//     can_update: false,
//     can_delete: false,
//   }));

export const organizerRoute = [
  // {
  //   key: "organizers",
  //   can_read: false,
  //   can_create: false,
  //   can_update: false,
  //   can_delete: false,
  // },
  {
    key: "exhibitors",
    can_read: false,
    can_create: false,
    can_update: false,
    can_delete: false,
  },
  {
    key: "products",
    can_read: false,
    can_create: false,
    can_update: false,
    can_delete: false,
  },
  {
    key: "articles",
    can_read: false,
    can_create: false,
    can_update: false,
    can_delete: false,
  },
  {
    key: "events",
    can_read: false,
    can_create: false,
    can_update: false,
    can_delete: false,
  },
  {
    key: "exhibitor-events",
    can_read: false,
    can_create: false,
    can_update: false,
    can_delete: false,
  },
  {
    key: "offers",
    can_read: false,
    can_create: false,
    can_update: false,
    can_delete: false,
  },
  {
    key: "banners-add",
    can_read: false,
    can_create: false,
    can_update: false,
    can_delete: false,
  },
  {
    key: "banners-hero",
    can_read: false,
    can_create: false,
    can_update: false,
    can_delete: false,
  },
  {
    key: "banners-popup",
    can_read: false,
    can_create: false,
    can_update: false,
    can_delete: false,
  },
  {
    key: "banners-bubble",
    can_read: false,
    can_create: false,
    can_update: false,
    can_delete: false,
  },
  {
    key: "banners-flash",
    can_read: false,
    can_create: false,
    can_update: false,
    can_delete: false,
  },
  {
    key: "bulk-notification",
    can_read: false,
    can_create: false,
    can_update: false,
    can_delete: false,
  },
  {
    key: "floor-map",
    can_read: false,
    can_create: false,
    can_update: false,
    can_delete: false,
  },
  {
    key: "product-categories",
    can_read: false,
    can_create: false,
    can_update: false,
    can_delete: false,
  },
  {
    key: "event-categories",
    can_read: false,
    can_create: false,
    can_update: false,
    can_delete: false,
  },
  {
    key: "pavilions",
    can_read: false,
    can_create: false,
    can_update: false,
    can_delete: false,
  },
  {
    key: "exhibitor-categories",
    can_read: false,
    can_create: false,
    can_update: false,
    can_delete: false,
  },
  {
    key: "currency",
    can_read: false,
    can_create: false,
    can_update: false,
    can_delete: false,
  },
];
